import React from "react";

type Option = {
  label: string;
  value: string;
};

interface CustomToggleSelectProps {
  value: string;
  setValue: (val: string) => void;
  options: Option[];
  className?: string;
}

const CustomToggleSelect: React.FC<CustomToggleSelectProps> = ({
  value,
  setValue,
  options,
  className = "",
}) => {
  let widthClass = "w-[50%]";
  if (options.length == 3) {
    widthClass = "w-[33%]";
  }
  if (options.length == 4) {
    widthClass = "w-[25%]";
  }
  return (
    <div
      className={`form-default-size flex flex-row  p-1 bg-gray-100 ${className}`}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          className={`px-4 rounded-md cursor-pointer ${widthClass} ${
            value === opt.value
              ? "bg-primary shadow-xs text-btn-fg-primary font-semibold underline underline-offset-4"
              : "text-gray-500"
          }`}
          onClick={() => setValue(opt.value)}
          type="button"
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default CustomToggleSelect;
